import Wrapper from "../../../layout/Wrapper";
import AgentManageComponent from "../../../screens/callcenters/agents/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Management",
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AgentManageComponent />
		</Wrapper>
	);
}